import React from 'react';
import { ChevronRight, HeartHandshake, ShieldCheck } from 'lucide-react';
import './WorkyPricingTeaser.css';
import { LPChip } from '../../Pages/LandingPage';

interface WorkyPricingTeaserProps {
  readonly isMobile: boolean;
  readonly onPricingClick: () => void;
}

const WorkyPricingTeaser = ({ isMobile, onPricingClick }: WorkyPricingTeaserProps): React.ReactElement => {
  return (
    <section className='worky-pricing-teaser' id='pricing' aria-labelledby='worky-pricing-heading'>
      <div className='worky-pricing-teaser__inner'>
        <LPChip direction="left" text="Pricing" />
        <div className='worky-pricing-teaser__intro'>
          <h2 id='worky-pricing-heading' className={`worky-pricing-teaser__heading ${isMobile ? 'lph-carousel-heading-mobile' : 'lph-carousel-heading'}`}>
            <span>Built for care.</span>
            <span className='text-loop-text'>Priced with care.</span>
          </h2>
          <p className='worky-pricing-teaser__description'>
            The tools your agency needs,<br className='worky-pricing-teaser__desktop-break' /> at a price that makes sense.
          </p>
        </div>

        <div className='worky-pricing-teaser__panel'>
          <article className='worky-pricing-teaser__starting' aria-label='Starting price'>
            <div className='worky-pricing-teaser__card-label'>
              <HeartHandshake aria-hidden='true' strokeWidth={1.7} className='worky-pricing-teaser__starting-icon' />
              <h3>A simple starting point</h3>
            </div>
            <p className='worky-pricing-teaser__starting-label'>Starting at</p>
            <p className='worky-pricing-teaser__price'><span>$99</span><span>/mo</span></p>
            <p className='worky-pricing-teaser__starting-description'>Let’s find the right fit<br />for your agency.</p>
          </article>

          <article className='worky-pricing-teaser__guarantee' aria-label='Price-beat guarantee'>
            <div className='worky-pricing-teaser__guarantee-label'>
              <ShieldCheck aria-hidden='true' strokeWidth={1.7} />
              <span>Price-beat guarantee</span>
            </div>
            <h3 className='worky-pricing-teaser__promise'>
              Bring us a competitor’s price.<br />
              We’ll beat it.<br />
              <span className='text-loop-text'>Guaranteed.</span>
            </h3>
            <p className='worky-pricing-teaser__quote-description'>Share your quote with our team.</p>
          </article>
        </div>

        <div className='worky-pricing-teaser__actions'>
          <button type='button' className={`worky-pricing-teaser__cta ${isMobile ? 'lp-product-container-inner-button-mobile' : 'lp-product-container-inner-button'}`} onClick={onPricingClick}>
            Let’s talk pricing {!isMobile && <ChevronRight size={15} aria-hidden='true' />}
          </button>
        </div>
      </div>
    </section>
  );
};

export { WorkyPricingTeaser };
